<template>
    <div
      class="bg-white px-3"
      style="margin: -20px; margin-top: -1rem; margin-bottom: 0 !important"
    >
      <div v-if="createModel">
        <div class="mb-2 mt-2 pt-3">
          <template>
            <el-header>{{ com_info.com_no  }} - {{ com_info.title  }}</el-header>
          </template>
        </div>
        <el-form
          ref="form"
          :model="form"
          :label-width="layout.is_phone ? '80px' : '100px'"
        >
          <el-form-item prop="groupList">
              <el-table
                  :data="groupList"
                  border
                  style="width: 100%"
                  @selection-change="handleSelectionChange"
                  :row-class-name="tableRowClassName" 
              >
                  <el-table-column
                  align="center"
                  prop="name"
                  label="組別名稱"
                  ></el-table-column>
  
                  <el-table-column
                  align="center"
                  prop="total_score"
                  label="試卷總分"
                  ></el-table-column>
  
                  <el-table-column
                  align="center"
                  prop="participant_count"
                  label="比賽人數"
                  ></el-table-column>
  
                  <el-table-column
                  align="center"
                  prop="check_count"
                  label="未改試卷"
                  ></el-table-column>
  
                  <el-table-column
                  align="center"
                  prop="time"
                  label="時長限制"
                  ></el-table-column>
  
                  <el-table-column
                    align="center"
                    label="榜單顯示人數"
                  >
                    <template slot-scope="scope">
                      <div>
                        <!-- 显示模式 -->
                        <span v-if="!scope.row.isEditing" @click="startEditing(scope.$index)">
                          <el-tag type="warning">{{ scope.row.rank_num }}</el-tag>
                        </span>
                        
                        <!-- 编辑模式 -->
                        <el-input
                          v-else
                          v-model="scope.row.rank_num"
                          size="small"
                          @blur="stopEditing(scope.$index)"
                          @keyup.enter="stopEditing(scope.$index)"
                        ></el-input>
                        
                        <!-- 保存/取消按钮 -->
                        <div v-if="scope.row.isEditing" style="display: flex; justify-content: space-between; margin-top: 5px;">
                          <el-button size="mini" @click="stopEditing(scope.$index, true)">保存</el-button>
                          <el-button size="mini" type="danger" @click="stopEditing(scope.$index, false)">取消</el-button>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
  
                  <el-table-column prop="id" align="center" width="100" label="操作">
                  <template slot-scope="scope">
                      <el-button-group>
                      <el-button
                          size="mini"
                          plain
                          type="primary"
                          @click="addRanking(scope.row.id)"
                          >查看</el-button
                      >
                      </el-button-group>
                  </template>
                  </el-table-column>
              </el-table>
          </el-form-item>
  
        <div class="mb-2 mt-2 pt-3">
          
          <button-search
            :isphone="layout.is_phone"
            ref="buttonSearch"
            placeholder="搜索學生名稱"
            @search="searchEventTopic"
            :showGj="true"
          >
              <template #left>
              <el-button type="primary" v-auth="'add'+auth_val" @click="queue" size="mini">快速排名</el-button>
            </template>
            <template #from>
              <el-form inline ref="form" :model="fromTopic" label-width="100px">
                <el-form-item label="學生名稱" class="mb-0">
                  <el-input
                    size="small"
                    v-model="fromTopic.name"
                    placeholder="搜索學生名稱"
                  ></el-input>
                </el-form-item>

                <el-form-item label="學生編號" class="mb-0">
                  <el-input
                    size="small"
                    v-model="fromTopic.user_no"
                    placeholder="搜索學生編號"
                  ></el-input>
                </el-form-item>
  
                <el-form-item label="學校名稱" class="mb-0">
                  <el-input
                    size="small"
                    v-model="fromTopic.school_name"
                    placeholder="搜索學校名稱"
                  ></el-input>
                </el-form-item>
  
                <el-form-item label="學生郵件" class="mb-0">
                  <el-input
                    size="small"
                    v-model="fromTopic.email"
                    placeholder="搜索學生郵件"
                  ></el-input>
                </el-form-item>
  
  
                <el-form-item class="mb-0">
                  <el-button type="info" @click="searchEventTopic" size="small"
                    >搜索
                  </el-button>
                  <el-button size="small" @click="clearSearchTopic"
                    >清空篩選條件</el-button
                  >
                </el-form-item>
  
                
              </el-form>
            </template>
          </button-search>
        </div>
  
        <!-- 表格 -->
        <div class="mt-3 pt-2">
          <el-table
            :data="userTopicList"
            border
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
              <el-table-column align="center" prop="rank" label="排名">
              </el-table-column>
              <el-table-column align="center" prop="join_no" label="參加編號">
              </el-table-column>
                  
              <el-table-column align="center" prop="topic_no"  width="200"  label="試卷編號">
              </el-table-column>
              <el-table-column align="center" prop="user_no" label="學生編號">
              </el-table-column>
              <el-table-column align="center" prop="name" label="學生名稱">
              </el-table-column>
              <el-table-column align="center" prop="school_name" label="學校名稱">
              </el-table-column>
              <el-table-column align="center" prop="email" label="學生信箱">
              </el-table-column>
              <el-table-column align="center" prop="score" label="成績">
              </el-table-column>
              <el-table-column align="center" prop="yes_num" label="答對數量">
              </el-table-column>
              <el-table-column align="center" prop="use_time_text" label="做題時長">
              </el-table-column>
              <el-table-column align="center" prop="level_id" label="名次">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.level_id" placeholder="請選擇" @change="handleLevelChange(scope.row)">
                    <el-option
                      :key=0
                      label="未選擇"
                      :value=0>
                    </el-option>
                    <el-option
                      v-for="item in formQueue"
                      :key="item.id"
                      :label="item.level_name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
  
              
              <el-table-column prop="id" align="center" width="120" label="操作">
                  <template slot-scope="scope">
                  <el-button-group>
                      <el-button
                      size="mini"
                      plain
                      type="primary"
                      v-auth="'edit' + auth_val"
                      @click="updateTopic(scope.row)"
                      >修改分數</el-button
                      >
                  </el-button-group>
                  </template>
              </el-table-column>
          </el-table>
          <el-footer
              class="d-flex bg-white align-items-center px-0"
              style="float: right;"
          >
              <!-- 底部 -->
  
              <div style="flex: 1" class="px-2">
                  <el-pagination
                      :current-page="pageScore.current"
                      :page-sizes="pageScore.sizes"
                      :page-size="pageScore.size"
                      @size-change="handleScoreSizeChange"
                      @current-change="handleScoreCurrentChange"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="pageScore.total"
                  >
                  </el-pagination>
              </div>
          </el-footer>
        </div>
  
       
          
        </el-form>
        <div slot="footer" style="text-align: center; padding: 10px 0 30px 0">
          <el-button @click="resetForm">取 消</el-button>
          <el-button type="primary" @click="submit">發佈成績</el-button>
        </div>
  
        <el-dialog :close-on-click-modal="false"  title="修改名次" :visible.sync="createQueueModel" top="5vh" :width="layout.is_phone?'90%':'50%'">
          <!-- 表單内容 -->
          <el-form ref="form" :model="formQueue" :label-width="layout.is_phone ? '80px' : '100px'">
            <div v-for="(item, index) in formQueue" :key="item.id">
              <el-form-item :label="item.level_name" :prop="`score_${item.id}`">
                <el-input
                  v-model="item.minScore"
                  placeholder="最低分數"
                  clearable
                  size="small"
                  type="number"
                  style="width: 40%; display: inline-block;"
                ></el-input>
                <span style="margin: 0 10px;">-</span>
                <el-input
                  v-model="item.maxScore"
                  placeholder="最高分數"
                  clearable
                  size="small"
                  type="number"
                  style="width: 40%; display: inline-block;"
                ></el-input>
                <span v-if="item.scoreWarning" style="color: red;">{{ item.scoreWarning }}</span> <!-- 顯示错误信息 -->
              </el-form-item>
            </div>
          </el-form>
  
          <div slot="footer" class="dialog-footer">
            <el-button @click="createQueueModel = false">取 消</el-button>
            <el-button type="primary" @click="submitQueue">確 定</el-button>
          </div>
        </el-dialog>
      
  
          <el-dialog :close-on-click-modal="false"  title="修改成績" :visible.sync="createTopicModel" top="5vh" :width="layout.is_phone?'90%':'50%'">
              <!-- 表單内容 -->
              <el-form ref="form" :model="formTopic" :label-width="layout.is_phone?'80px':'100px'">
  
                  <el-form-item label="學生姓名" prop="name">
                      <el-input v-model="formTopic.name" disabled size="small" 
                       style="width: 85%;"></el-input>
                  </el-form-item>
                  <el-form-item label="學校" prop="school_name">
                      <el-input v-model="formTopic.school_name" disabled size="small"
                       style="width: 85%;"></el-input>
                  </el-form-item>
                  <el-form-item label="郵箱" prop="email">
                      <el-input v-model="formTopic.email" disabled size="small" style="width: 85%;"></el-input>
                  </el-form-item>
  
          <el-form-item label="目前排名" prop="rank">
                      <el-input v-model="formTopic.rank"   size="small" style="width: 85%;"></el-input>
                  </el-form-item>
  
                  <el-form-item label="分數" prop="score">
                      <el-input v-model="formTopic.score" placeholder="為空預設0" clearable size="small" style="width: 85%;"></el-input>
                  </el-form-item>
                  
                  <el-form-item label="做題時長" prop="use_time">
                      <el-input v-model="formTopic.use_time" placeholder="為空預設0" clearable size="small" style="width: 85%;"></el-input>
                  </el-form-item>
              </el-form>
  
  
              <div slot="footer" class="dialog-footer">
                  <el-button @click="createTopicModel = false">取 消</el-button>
                  <el-button type="primary" @click="submitTopic">確 定</el-button>
              </div>
          </el-dialog>
      </div>
  
      <div v-else>
        <div class="mb-2 mt-2 pt-3">
          <button-search
            :isphone="layout.is_phone"
            ref="buttonSearch"
            placeholder="搜索登錄標題"
            @search="searchEvent"
            :showGj="true"
          >
            <!-- 左边 -->
  
            <!-- 高級搜索 -->
            <template #from>
              <el-form inline ref="form" :model="from" label-width="100px">
                <el-form-item label="比賽名稱" class="mb-0">
                  <el-input
                    size="small"
                    v-model="from.title"
                    placeholder="搜索比賽名稱"
                  ></el-input>
                </el-form-item>
  
                <el-form-item label="是否收費" class="mb-0">
                  <el-select v-model="from.pay_type" size="small">
                    <el-option label="全部" :value="-1"></el-option>
                    <el-option label="免費" :value="1"></el-option>
                    <el-option label="收費" :value="2"></el-option>
                  </el-select>
                </el-form-item>
  
                <el-form-item label="狀態" class="mb-0">
                  <el-select v-model="from.status" size="small">
                    <el-option label="全部" :value="-1"></el-option>
                    <el-option label="啟用" :value="1"></el-option>
                    <el-option label="禁用" :value="0"></el-option>
                  </el-select>
                </el-form-item>
  
                <el-form-item label="創建時間" size="small" class="mb-0">
                  <el-date-picker
                    v-model="from.time"
                    type="daterange"
                    align="right"
                    unlink-panels
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="開始日期"
                    end-placeholder="結束日期"
                    :picker-options="pickerOptions"
                  >
                  </el-date-picker>
                </el-form-item>
  
                <el-form-item class="mb-0">
                  <el-button type="info" @click="searchEvent" size="small"
                    >搜索
                  </el-button>
                  <el-button size="small" @click="clearSearch"
                    >清空篩選條件</el-button
                  >
                </el-form-item>
  
                
              </el-form>
            </template>
          </button-search>
          
        </div>
  
        <!-- 表格 -->
        <div class="mt-3 pt-2">
          <el-table
            :data="tableData"
            border
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
         
            <el-table-column align="center" prop="com_no" label="比賽編號">
            </el-table-column>

            <el-table-column align="center" prop="title" label="比賽名稱">
								<template slot-scope="scope">
									<div v-if="scope.row.title.length > 20">
										{{ scope.row.title.substring(0, 20) }}... 
										<el-button type="text" @click="showFullTitle(scope.row.title)">點擊查看</el-button>
									</div>
									<div v-else>
										{{ scope.row.title }}
									</div>
								</template>
					</el-table-column>

            
            <el-table-column align="center" prop="subject_name" label="學科名稱">
            </el-table-column>
  
            <el-table-column
              align="center"
              width="100"
              prop="content"
              label="簡介"
            >
              <template slot-scope="scope">
                <el-popover
                  trigger="click"
                  style="cursor: pointer"
                  placement="top"
                >
                  <p style="width: 300px">{{ scope.row.content }}</p>
                  <div slot="reference" class="name-wrapper">
                    <el-tag size="medium">查看</el-tag>
                  </div>
                </el-popover>
              </template>
            </el-table-column>
  
            <el-table-column align="center" prop="pay_type" label="費用">
              <template slot-scope="scope">
                <span v-if="scope.row.pay_type == 1">免費</span>
                <span class="text-success" v-if="scope.row.pay_type == 2">{{
                  scope.row.money
                }}</span>
              </template>
            </el-table-column>
  
            <el-table-column align="center" prop="school_name" label="參加學校">
            </el-table-column>
  
            <el-table-column align="center" prop="start_status" label="成績狀態">
              <template slot-scope="scope">
                <span class="text-success" v-if="scope.row.start_status == 3"
                  >已公佈</span
                >
                <span class="text-danger" v-else>未公佈</span>
              </template>
            </el-table-column>
  
            <el-table-column align="center" prop="status" label="狀態">
              <template slot-scope="scope">
                <el-button
                  :type="scope.row.status ? 'success' : 'danger'"
                  size="mini"
                  @click="changeStatus(scope.row)"
                  plain
                  >{{ scope.row.status ? "顯示" : "隱藏" }}
                </el-button>
              </template>
            </el-table-column>
  
            <el-table-column
              align="center"
              width="180"
              prop="create_time"
              label="創建時間"
            >
            </el-table-column>
            <el-table-column prop="id" align="center" width="120" label="操作">
              <template slot-scope="scope">
                <el-button-group>
                 
                  <el-button
                   
                    size="mini"
                    plain
                    type="primary"
                    v-auth="'edit' + auth_val"
                    @click="openModel(scope.row.id)"
                    >公佈成績</el-button
                  >
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-dialog :close-on-click-modal="false"  :visible.sync="dialogTitleVisible" title="題目">
			<p>{{ fullTitle }}</p>
		</el-dialog>
        <div style="height: 60px"></div>
        <el-footer
          class="d-flex border-top bg-white align-items-center px-0 position-fixed"
          style="bottom: 0; left: 200px; right: 0; z-index: 100"
        >
          <!-- 底部 -->
  
          <div style="flex: 1" class="px-2">
            <el-pagination
              :current-page="page.current"
              :page-sizes="page.sizes"
              :page-size="page.size"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.total"
            >
            </el-pagination>
          </div>
        </el-footer>
      </div>
    </div>
  </template>
  
  <script>
  import { commondecrypt } from "@/main";
  import common from "@/common/mixins/common.js";
  import buttonSearch from "@/components/common/button-search.vue";
  export default {
    components: {
      buttonSearch,
    },
    inject: ["layout", "app"],
    mixins: [common],
    data() {
      return {
        dialogTitleVisible: false,
				fullTitle: '',
        selectedRowId: null,  // 保存选中行的ID
        createModel: false,
        createQueueModel: false,
        editIndex: -1,
  
        com_info:[],
        rankList:[],
  
        createTopicModel:false,
        formTopic:{},
        formQueue:{},
      
        scoreId: 0,
        pageScore: {
                  current: 1,
                  sizes: [50, 100, 200, 300, 500],
                  size: 200,
                  total: 0
              },
        //搜索數据
        from: {
          title: "",
          pay_type: -1,
          status: -1,
          time: [],
        },
        //搜索數据
        fromTopic: {
          name: "",//學生名稱
          user_no:"",
          school_name: "",//學校名稱
          email: "",//學生郵件
        },
        auth_val: "Shop",
        preUrl: "data/competitionEndList", //列表地址
        delAllUrl: "data/delCompetitionAll", //批量删除地址
        delUrl: "data/delCompetition", //删除單条地址
        addUrl: "data/editCompetition", //添加/修改地址
        editStatusUrl: "data/editStatusCompetition", //修改狀態地址
  
        tableData: [],
        form: {},
        groupList: [],//比賽科目列表
        userTopicList: [],//參加科目學生列表
        
        label_ids: null,
       
  
        active: 0, //步骤數
        inputVisible: false,
        inputValue: "",
        label_list: [],
        all_label_list: [],
        subject_list: [],
        school_list: [],
        grade_list: [],
        rule_list: [],
        check_img_list: [],
      };
    },
  
    created() {
      this.commonList(["school_list", "topic_subject_label"]);
    },
    computed: {
      
      processedGradeList() {
        // 創建一个新數組，確保不直接修改原始數据
        return this.grade_list.map((grade) => {
          // 检查 this.form.paperList 中任一 paper 的 grade_id 數組是否包含當前 grade 的 id
          const isDisabled = this.form.paperList.some((paper) =>
            paper.grade_id.includes(Number(grade.id))
          );
          // 返回新的对象，并可能添加 disabled 属性
          return {
            ...grade,
            disabled: isDisabled,
          };
        });
      },
    },
    methods: {
     
       //修改排序
      queue(){
        this.createQueueModel = true;
      },
      handleLevelChange(row) {
          row.rank_type = 1
          this.layout.loading = true;
          // 在这里可以执行其他逻辑，例如更新數据或触发其他操作
          this.axios.post(
            "/admin/data/updateRank",
            row,
            {
              token: true,
            }
          )
          .then((res) => {
            // 修改成功则不操作
            this.layout.loading = false;
          })
          .catch((err) => {
            // 修改失敗时恢复下拉框选项值
            this.layout.loading = false; // 停止加載狀態
          });
        },
        	 // 顯示完整標題内容
			 showFullTitle(title) {
				this.fullTitle = title;
				this.dialogTitleVisible = true;
			},
      submitQueue() {
        this.layout.loading = true;
        this.axios.post(
              "/admin/data/updateRank",
              {rank_type:2,data:this.formQueue},
              {
                  token: true,
              }
              )
              .then((res) => {
                  this.addRanking(this.formTopic.com_info_id)
                  this.createQueueModel = false;
              })
              .catch((err) => {
              // 失敗
              this.layout.loading = false;
              this.createQueueModel = false; // 關閉模型
        });
      
      },
       // 清空篩選條件
       clearSearchTopic() {
        this.fromTopic = {
          name: "",//學生名稱
          user_no:"",
          school_name: "",//學校名稱
          email: "",//學生郵件
        };
  
        //this.$refs.buttonSearch.closeSuperSearch();
        this.search = "";
        this.getList();
      },
      searchEventTopic(e = false) {
              // 簡單搜索
              if (typeof e === 'string') {
                  this.search = e;
                  this.getUserTopicList()
                  return
              }
              this.search = this.fromTopic
              this.getUserTopicList()
          },
      startEditing(index) {
        // 设置当前行为编辑模式
        
      },
      stopEditing(index, save = true) {
        // 停止编辑，根据 save 參數决定是否保存更改
        if (save) {
          // 这里可以添加验证逻辑，確保輸入是有效的數字
          const newRankNum = parseInt(this.tableData[index].rank_num, 10);
          if (!isNaN(newRankNum)) {
            // 假设你的數据數組是 tableData
            this.$set(this.tableData, index, {
              ...this.tableData[index],
              isEditing: false,
              rank_num: newRankNum
            });
          } else {
            // 如果輸入无效，则恢复旧值并取消编辑
            this.$alert('請輸入有效的數字', '警告', {
              confirmButtonText: '確定'
            });
            this.startEditing(index); // 重新进入编辑模式，或者你可以選擇其他方式处理错误
          }
        } else {
          // 取消编辑，恢复旧值
          this.$set(this.tableData, index, {
            ...this.tableData[index],
            isEditing: false
            // 註意：这里不需要重新设置 rank_num，因为 Vue 的响应式系统不会覆盖未更改的属性
          });
        }
      },
      //修改成績弹框
      updateTopic(data){
          this.formTopic = {
              score : data.score,
              use_time : data.use_time,
              name : data.name,
              school_name : data.school_name,
              email : data.email,
              rank : data.rank,
              com_info_id : data.com_info_id,
              id : data.is_none,
              user_com_id : data.id,
          }
          this.createTopicModel = true;
      },
     
      //修改成績并重新排名
      submitTopic(){
          this.axios
              .post(
              "/admin/data/updateTopic",
              this.formTopic,
              {
                  token: true,
              }
              )
              .then((res) => {
                  this.addRanking(this.formTopic.com_info_id)
                  this.createTopicModel = false;
              })
              .catch((err) => {
              // 失敗
              this.layout.loading = false;
          });
         
          this.resetTagForm();
      },
      // 打开模态框
      openModel(e) {
        this.layout.loading = true;
        this.axios
          .post(
            "/admin/data/getGroupList",
            {
              id: e,
            },
            {
              token: true,
            }
          )
          .then((res) => {
            
            this.groupList = res.data.data.list.list,
            this.com_info = res.data.data.list.com_info
            this.editIndex = e;
            // 打开dialog
            this.createModel = true;
            this.layout.loading = false;
          })
          .catch((err) => {
            // 失敗
            this.layout.loading = false;
          });
      },
      tableRowClassName({ row }) {
        // 判断行的 ID 是否与选中的 ID 相等，返回不同的類名
        return row.id === this.selectedRowId ? 'selected-row' : '';
      },
      addRanking(e){
          if(e){
              this.scoreId = e;
              this.selectedRowId = e;
          }
          this.layout.loading = true;
          this.axios
              .post(
              "/admin/data/getUserTopicList",
              {
                  id: this.scoreId,
                  page: this.pageScore.current,
                          limit: this.pageScore.size,
              },
              {
                  token: true,
              }
              )
              .then((res) => {
                  let all = res.data.data.list
                  this.pageScore.total = all.total
                  this.userTopicList = all.list
                  this.formQueue = all.rank
                  this.layout.loading = false;
              })
              .catch((err) => {
              // 失敗
              this.layout.loading = false;
          });
      },
      getUserTopicList(){
          this.layout.loading = true;
          this.axios
              .post(
              "/admin/data/getUserTopicList",
              {
                id: this.scoreId,
                search: this.search,
              },
              {
                token: true,
              }
              )
              .then((res) => {
                  let all = res.data.data.list
                  this.pageScore.total = all.total
                  this.userTopicList = all.list
                  this.formQueue = all.rank
                  this.layout.loading = false;
              })
              .catch((err) => {
              // 失敗
              this.$message.error(err);
              this.layout.loading = false;
          });
      },
      handleScoreSizeChange(val) {
              this.pageScore.size = val
              this.addRanking()
      },
      handleScoreCurrentChange(val) {
          this.pageScore.current = val
          this.addRanking()
      },
      //提交成績
    submit() {
      
          this.$confirm('您確定要提交發布？', '提示', {
            confirmButtonText: '確定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            // 用戶確認提交
            this.form.id = this.editIndex;
            this.search = this.from
            this.addOrEdit(this.form);
        }).catch(() => {
            // 用戶取消提交，您可以在这里添加任何需要的逻辑
            console.log('取消');
        });
          
      },
  
  
  
  
      // 自定义時間验证规则
      validateTime(rule, value, callback) {
        if (this.formPaper.timeArr.length === 2) {
          const startTime = this.convertTimeToMinutes(this.formPaper.timeArr[0]);
          const endTime = this.convertTimeToMinutes(this.formPaper.timeArr[1]);
          const selectedTime = parseInt(value);
  
          if (isNaN(selectedTime)) {
            callback(new Error("請輸入有效的做題时長"));
          } else if (selectedTime > endTime - startTime) {
            callback(new Error("做題时長不能超過比賽時間范围"));
          } else {
            callback();
          }
        } else {
          callback(new Error("請選擇比賽時間范围"));
        }
      },
      // 辅助方法：将時間转为分钟數
      convertTimeToMinutes(time) {
        const [hours, minutes, seconds] = time.split(":").map(Number);
        return hours * 60 + minutes + seconds / 60;
      },
      changeType() {
        // 清空當前的 label_list
        this.label_list = [];
  
        // 遍历每个 grade_id 来构建键，并合并结果
        this.formPaper.grade_id.forEach((gradeId) => {
          let key = `${this.form.subject_id}-${gradeId}`;
          if (this.all_label_list[key]) {
            this.label_list = [...this.label_list, ...this.all_label_list[key]];
          }
        });
  
        // 移除可能的重复项，假设每个標籤有唯一的 id
        this.label_list = this.label_list.filter(
          (label, index, self) =>
            index === self.findIndex((t) => t.id === label.id)
        );
  
        if (this.label_list.length > 0) {
          // 如果 label_list 不为空，则设置默認选中项为第一个元素的 ID
          this.label_ids = this.label_list[0].id;
        } else {
          // 如果 label_list 为空，可以设置 label_id 为 null 或进行其他逻辑處理
          this.label_ids = null;
        }
      },
      next() {
        if (this.active++ > 2) this.active = 0;
      },
      createModelbut() {
        this.createModel = false;
        this.active = 0;
      },
      createPaperModelbut() {
        this.createPaperModel = false;
      },
      addTag(e = false) {
        // 增加
        if (!e) {
          if (!this.formPaper.grade_id || this.formPaper.grade_id.length === 0) {
            this.$message.error("請選擇先選擇年級!");
            return; // 提前返回，不执行後面的添加或修改逻辑
          }
          (this.topForm.label_id = this.label_ids),
            // 初始化表單
            (this.editTagIndex = -1);
        } else {
          // 修改
          this.topForm = {
            title: e.row.title,
            answer: e.row.answer,
            icon: e.row.img,
            img: e.row.img,
  
            label_id: e.row.label_id,
            label_name: e.row.label_name,
            topic_type: e.row.topic_type,
            option_a: e.row.option_a,
            option_b: e.row.option_b,
            option_c: e.row.option_c,
            option_d: e.row.option_d,
            selectedLabel: e.row.selectedLabel,
            score: e.row.score,
            status: 0,
            use_time: 0,
            sel_time: 0,
            option_sel: "",
          };
          this.editTagIndex = e.$index;
        }
  
        this.createTagModel = true;
      },
  
      handleTagClose(tag) {
        this.topicTags.splice(this.topicTags.indexOf(tag), 1);
      },
  
      //添加題目
      submitTag() {
        this.$refs.topForm.validate((valid) => {
          if (valid) {
            this.handleLabelChange(this.topForm.label_id);
            if (this.editTagIndex === -1) {
              // 添加新題目
              this.formPaper.topList.push(this.topForm);
            } else {
              // 修改现有題目
              this.$set(this.formPaper.topList, this.editTagIndex, {
                ...this.topForm,
              });
            }
  
            // 计算數量和分數總和
            this.formPaper.total_score = this.formPaper.topList.reduce(
              (sum, item) => sum + Number(item.score),
              0
            );
  
            this.formPaper.count = this.formPaper.topList.length;
            // 重置表單和關閉模态框
            this.resetTagForm();
          }
        });
      },
      resetTagForm() {
        this.topForm = {
          title: "",
          answer: "",
          icon: "",
          img: "",
          label_id: this.label_ids,
          label_name: "",
          topic_type: 1,
          option_a: "",
          option_b: "",
          option_c: "",
          option_d: "",
          score: 10,
          status: 0,
          use_time: 0,
          sel_time: 0,
          option_sel: "",
        };
        this.createTagModel = false;
        this.editTagIndex = -1; // 重置 editTagIndex
      },
  
      //添加修改獎品
      addPrize(e = false) {
        if (!e) {
          // 初始化表單
          this.editPrizeIndex = -1;
        } else {
          // 修改
          this.formPrize = {
            name: e.row.name,
            money: e.row.money,
            content: e.row.content,
          };
          this.editPrizeIndex = e.$index;
        }
        // 打开dialog
        this.createPrizeModel = true;
      },
      submitPrize() {
        this.$refs.formPrize.validate((valid) => {
          if (valid) {
            if (this.editPrizeIndex === -1) {
              // 添加新題目
              this.formRanking.prize.push(this.formPrize);
            } else {
              // 修改现有題目
              this.$set(this.formRanking.prize, this.editPrizeIndex, {
                ...this.formPrize,
              });
            }
  
            // 重置表單和關閉模态框
            this.resetPrizeForm();
          }
        });
      },
      resetPrizeForm() {
        this.formPrize = {
          name: "",
          money: 0,
          content: "",
        };
  
        this.createPrizeModel = false;
        this.editPrizeIndex = -1; // 重置 editTagIndex
      },
  
    
      submitRanking() {
        this.$refs.formRanking.validate((valid) => {
          if (valid) {
            if (this.editRankingIndex === -1) {
              // 添加新題目
              this.form.ranking.push(this.formRanking);
            } else {
              // 修改现有題目
              this.$set(this.form.ranking, this.editRankingIndex, {
                ...this.formRanking,
              });
            }
  
            // 重置表單和關閉模态框
            this.resetRankingForm();
          }
        });
      },
      resetRankingForm() {
        this.formRanking = {
          level_name: "",
          prize: [],
          sum: 1,
        };
  
        this.createRankingModel = false;
        this.editRankingIndex = -1; // 重置 editTagIndex
      },
  
      //添加試卷
      submitPaper() {
        this.$refs.formPaper.validate((valid) => {
          if (valid) {
            if (this.editPaperIndex === -1) {
              // 添加新題目
              this.form.paperList.push(this.formPaper);
            } else {
              // 修改现有題目
              this.$set(this.form.paperList, this.editPaperIndex, {
                ...this.formPaper,
              });
            }
  
            // 重置表單和關閉模态框
            this.resetPaperForm();
          }
        });
      },
  
      resetPaperForm() {
        this.formPaper = {
          name: "",
          timeArr: [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)],
          time: 60,
          total_score: 0,
          count: 0,
          topList: [], //題目數組
          grade_id: [], //年級數組
        };
  
        this.createPaperModel = false;
        this.editPaperIndex = -1; // 重置 editTagIndex
      },
      addDomain(e = false) {
        if (!e) {
          // 初始化表單
          this.editPaperIndex = -1;
        } else {
          // 修改
          this.formPaper = {
            name: e.row.name,
            time: e.row.time,
            timeArr: e.row.timeArr,
            total_score: e.row.total_score,
            count: e.row.count,
            topList: e.row.topList,
            grade_id: e.row.grade_id.map((id) => Number(id)),
          };
          this.editPaperIndex = e.$index;
        }
        // 打开dialog
        this.createPaperModel = true;
      },
  
      handleLabelChange(value) {
        if (this.label_list.length > 0) {
          const selectedItem = this.label_list.find((item) => item.id === value);
          this.topForm.label_name = selectedItem.name; // 获取和存储 name
        }
      },
  
      resetForm() {
        this.form = {
          subject_id: null,
          title: "",
          content: "",
          subject_id: this.form.subject_id,
          school_id: [],
          pay_type: 1,
          is_school: 0,
          money: 0,
          time: [],
          com_time: null,
          paperList: [], //試卷數組
          ranking: [], //試卷數組
        };
  
        this.createModel = false;
        this.editIndex = -1; // 重置 editTagIndex
      },
  
      //公共列表
      commonList(type) {
        this.layout.loading = true;
        this.axios
          .post(
            "/admin/user/commonList",
            {
              type: type,
            },
            {
              token: true,
            }
          )
          .then((res) => {
            let all = res.data;
            let list = all.data.list;
            this.school_list = list.school;
            this.grade_list = list.grade;
            this.subject_list = list.subject;
            this.all_label_list = list.label;
  
            if (this.subject_list.length > 0) {
              // 设置默認选中项为subject_list中的第一个元素
              this.form.subject_id = this.subject_list[0].id;
              this.label_list = list.label[this.subject_list[0].id];
              if (this.label_list.length > 0) {
                // 设置默認选中项为subject_list中的第一个元素
                this.label_ids = this.label_list[0].id;
              }
            }
            this.layout.loading = false;
          })
          .catch((err) => {
            // 失敗
            this.layout.loading = false;
          });
      },
      handleAvatarSuccess(res, file) {
        this.topForm.icon = URL.createObjectURL(file.raw);
        let en_data = commondecrypt(res.encryption);
        res.encryption = JSON.parse(en_data);
        if (res.encryption.code == 1) {
          this.topForm.img = res.encryption.data.list.url;
        }
      },
      beforeAvatarUpload(file) {
        const isJPG =
          file.type === "image/jpeg" ||
          file.type === "image/png" ||
          file.type === "image/gif";
        const isLt2M = file.size / 1024 / 1024 < 2;
  
        if (!isJPG) {
          this.$message.error("文件格式错误!");
        }
        if (!isLt2M) {
          this.$message.error("上傳图片大小不能超過 2MB!");
        }
        return isJPG && isLt2M;
      },
      //前往修改页面
      editItem(obj) {
        this.$router.push({
          name: "set_manager_rule",
          query: {
            item: obj,
          },
        });
      },
      handleClose(done) {
        this.active = 0;
        done();
      },
      getListResult(e) {
        this.tableData = e.list;
        this.check_img_list = e.list.map((item) => {
          return item.head;
        });
      },
      // 清空篩選條件
      clearSearch() {
        this.from = {
          title: "",
          pay_type: -1,
          status: -1,
          apply_status: -1,
          start_status: -1,
          time: [],
        };
  
        //this.$refs.buttonSearch.closeSuperSearch();
        this.search = "";
        this.getList();
      },
      // 選擇图片
      chooseImage() {
        this.app.chooseImage((res) => {
          this.$set(this.form, "headUrl", res[0].url);
          this.form["headId"] = res[0].id;
          this.$set(this.form, "headId", res[0].id);
        }, 1);
      },
    },
  };
  </script>
  
  <style>
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
  .selected-row {
    background-color: #f0f9ff !important; /* 选中行的背景颜色 */
  }
  </style>
  